// Per-state, per-pillar beneficiary split — computed deterministically from
// each state's active pillars + global pillar weights (FY 24-25 mix).

import { STATE_REACH } from "./states";
import { PILLARS, PILLAR_WEIGHTS } from "./pillars";

const PILLAR_IDS = PILLARS.map((p) => p.id);
const emptySplit = () => PILLAR_IDS.reduce((acc, id) => { acc[id] = 0; return acc; }, {});

export function pillarSplitForState(s) {
  const active = s.pillars;
  const totalWeight = active.reduce((sum, pid) => sum + (PILLAR_WEIGHTS[pid] || 0), 0);
  const out = emptySplit();
  active.forEach((pid) => {
    out[pid] = totalWeight
      ? Math.round(s.beneficiaries * ((PILLAR_WEIGHTS[pid] || 0) / totalWeight))
      : 0;
  });
  return out;
}

export const STATE_PILLAR_MATRIX = STATE_REACH.map((s) => {
  const split = pillarSplitForState(s);
  return {
    state: s.state,
    total: s.beneficiaries,
    ...split,
  };
});
